import { memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';

import QrCodeRoundedIcon from '@mui/icons-material/QrCodeRounded';

import AutoSaveTextField from '../../../../common/components/AutoSaveTextField';
import BarcodeReaderModal from '../../../../common/components/BarcodeReaderModal';

import { NcrTemplateContext } from '../../../../common/contexts/ncrTemplate/store/context';

import { useModal } from '../../../../common/hooks/useModal';

const ReferenceInputComponent = ({ value, disabled }) => {
    const { t } = useTranslation();
    const [isOpened, toggleModal] = useModal(false);

    const { setNCR } = useContext(NcrTemplateContext);

    const handleChange = event => {
        setNCR({ value: event?.target?.value, path: 'basicInformation.externalReference' });
    };

    const handleResult = result => {
        if (!!result && isOpened) {
            setNCR({ value: result, path: 'basicInformation.externalReference' });
            toggleModal();
        }
    };

    return (
        <>
            <AutoSaveTextField
                error={!value}
                required
                value={value}
                disabled={disabled}
                InputProps={{
                    endAdornment: <QrCodeRoundedIcon onClick={toggleModal} />,
                }}
                label={t('report.form.reference')}
                onBlur={handleChange}
                fullWidth
            />
            <BarcodeReaderModal isOpen={isOpened} handleModalClose={toggleModal} handleResult={handleResult} />
        </>
    );
};

const ReferenceInput = memo(ReferenceInputComponent);

export default ReferenceInput;
